import React from 'react';
import styled from 'styled-components';
import {Modal, Button} from 'react-bootstrap'

const ModalDelete = ({show, text, cancel,remove, children}) => {

    const DeleteModal = styled.div`
      .title-message{
        font-size: 1.8rem; 
        color:#d90000;
        font-weight:900;
      }
  
      .important-message{
        font-size: 1.6rem; 
        color:#d90000;
        font-weight:900;
        padding:20px;
      }
  
      .normal-text{
        font-size: 1.5rem ; 
        
      }
  
      .danger-button{
        background-color:#d90000;
        color:white;
      }
    `
  
    return (
      
        <Modal show={show} onHide={() => cancel({})}>
          <DeleteModal>
          <Modal.Header closeButton>
              
            <Modal.Title><div className="title-message"> <i class="fas fa-exclamation-circle"/> Attention!</div></Modal.Title>
          </Modal.Header>
          <Modal.Body>

            {
              !children && 
              <div>
                <div className="normal-text">
                  {text}
                </div>
                <div className="important-message">
                  This action cannot be undone.
                </div>
              </div>    
            }

            {children}
  
          </Modal.Body>
          <Modal.Footer>
            <Button className="danger-button" variant="danger" onClick={() => {remove()}}>
              Remove
            </Button>
            <Button onClick={() => {cancel({})}}>
              Cancel
            </Button>
          </Modal.Footer>
          </DeleteModal>
        </Modal>
    )
  }
  
  export default ModalDelete;